<ion-content class="theme-{{userService.theme}}">
    <ion-header [ngClass]="userService.theme" class="transparent absolute">
        <app-header [middleIcon]="false" [hide930]="true"></app-header>
    </ion-header>
<div class="blue-bg" [ngClass]="'bg-inner-'+userService.theme">
    <div class="content-wrap">
        <img class="side-logo" [src]="userService.companyLogo">
        <div class="box" [@enter]>
            <div class="title my-color-blue">{{"__ACCOUNT_DETAILS__" | translate}}</div>
            <img [src]="userService.headerMode === 'light' ? 'assets/img/menu/user-black.svg' : 'assets/img/menu/user.svg'" alt="#">
        </div>

        <div class="small-text" [@enter]>{{"__ACCOUNT_DESC1__" | translate}}</div>
        <div class="text" [@enter]>{{"__ACCOUNT_DESC2__" | translate}}</div>
    </div>
</div>

<div *ngIf="profileModel !== null" class="account-wrap" [@enter]>
    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="content-wrap" novalidate>
    <div class="input-box" [ngClass]="{error: profileForm.controls['first_name'].invalid}">
        <div class="text">{{"__ACCOUNT_FIRST_NAME__" | translate}}:</div>
        <ion-input formControlName="first_name" type="text" class="my-input-grey" [autocomplete]="'name'"
                   [@headShake]="profileForm.controls['first_name'].invalid && animationState"></ion-input>
        <div class="error-text">{{"__ACCOUNT_FIELD_REQ__" | translate}}</div>
    </div>

    <div class="input-box" [ngClass]="{error: profileForm.controls['last_name'].invalid}">
        <div class="text">{{"__ACCOUNT_LAST_NAME__" | translate}}:</div>
        <ion-input formControlName="last_name" type="text" class="my-input-grey" [autocomplete]="'family-name'"
                   [@headShake]="profileForm.controls['last_name'].invalid && animationState"></ion-input>
        <div class="error-text">{{"__ACCOUNT_FIELD_REQ__" | translate}}</div>
    </div>

    <div class="input-box">
        <div class="text">{{"__ACCOUNT_PHONE__" | translate}}:</div>
        <ion-input formControlName="phone" type="text" class="my-input-grey" [autocomplete]="'tel'"
                   [@headShake]="profileForm.controls['phone'].invalid && animationState"></ion-input>
        <div class="error-text">{{"__ACCOUNT_FIELD_REQ__" | translate}}</div>
    </div>

    <div class="input-box" [ngClass]="{error: profileForm.controls['email'].invalid}">
        <div class="text">{{"__ACCOUNT_EMAIL__" | translate}}:</div>
        <ion-input formControlName="email" type="email" class="my-input-grey" [autocomplete]="'email'"
                   [@headShake]="profileForm.controls['email'].invalid && animationState"></ion-input>
        <div class="error-text">{{"__ACCOUNT_FIELD_REQ__" | translate}}</div>
    </div>

    <div class="input-box">
        <div class="text">{{"__ACCOUNT_LOGIN__" | translate}}:</div>
        <ion-input type="email" class="my-input-grey grey" [autocomplete]="'username'"
                   [value]="profileModel.login" [disabled]="true"></ion-input>
    </div>

    <div class="input-box" [ngClass]="{error: profileForm.controls['password1'].invalid}">
        <div class="text">{{"__ACCOUNT_PASS1__" | translate}}:</div>
        <ion-input formControlName="password1" type="password" [autocomplete]="'new-password'"
                    class="my-input-grey"></ion-input>
        <div class="error-text" *ngIf="profileForm.controls['password1'].invalid
        && profileForm.controls['password1'].errors.hasOwnProperty('minlength')">{{"__ACCOUNT_PASSWORD_SHORT__" | translate}}</div>
        <div class="error-text" *ngIf="profileForm.controls['password1'].invalid
        && !profileForm.controls['password1'].errors.hasOwnProperty('minlength')
        && profileForm.controls['password1'].errors.hasOwnProperty('pattern')">{{"__ACCOUNT_PASSWORD_WRONG__" | translate}}</div>
        <div class="error-text" *ngIf="profileForm.controls['password1'].invalid
        && profileForm.controls['password1'].errors.hasOwnProperty('custom')
        && profileModel.password1.error">{{profileModel.password1.error}}</div>
    </div>

    <div class="input-box" [ngClass]="{error: profileForm.controls['password2'].invalid}">
        <div class="text">{{"__ACCOUNT_PASS2__" | translate}}:</div>
        <ion-input formControlName="password2" type="password" [autocomplete]="'new-password'"
                    class="my-input-grey"></ion-input>
        <div class="error-text">{{"__ACCOUNT_PASSWORD_MATCH__" | translate}}</div>
    </div>

    <div class="input-box">
        <div class="text">{{"__ACCOUNT_LANGUAGE__" | translate}}:</div>
        <ng-select class="My-dropdown" formControlName="lang_id"
                   [placeholder]="'__ACCOUNT_LANGUAGE_PLACEHOLDER__' | translate"
                   [notFoundText]="'__NG_SELECT_NO_ITEMS_FOUND__' | translate"
                   [searchable]="false"
                   [clearable]="false">
          <ng-option *ngFor="let language of profileModel.available_languages" [value]="language.id">
            {{language.code_title}}
          </ng-option>
        </ng-select>
    </div>

    <div class="input-box">
      <div class="text">{{"__ACCOUNT_COMPANY__" | translate}}:</div>
      <ion-input class="my-input-grey grey"  [disabled]="true" [autocomplete]="'organization'"
                 [value]="profileModel.company_name"></ion-input>
    </div>

    <button type="submit" class="save">
      <app-inline-svg [cssClass]="'touch-eff-radius'" [file]="'assets/img/journey/save-btn.svg'"></app-inline-svg>
    </button>

    </form>
</div>
</ion-content>
